import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import ServitiLogo from '../components/common/ServitiLogo';

// An unknown address used to redirect to /welcome, so a stale bookmark or a
// mistyped link landed on a sign-up greeting with no hint of what went wrong
// and no way back.
const NotFoundPage = () => {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  useEffect(() => {
    document.title = 'Page not found · Serviti AI';
  }, []);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-50 px-6 text-center dark:bg-gray-900">
      <ServitiLogo alt="Serviti" className="h-10" />
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">That page doesn&rsquo;t exist</h1>
      <p className="max-w-md text-sm text-gray-600 dark:text-gray-300">
        Nothing lives at{' '}
        <code className="break-all rounded bg-gray-100 px-1.5 py-0.5 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
          {location.pathname}
        </code>
        . The link may be old or mistyped.
      </p>
      <Link
        to={isAuthenticated ? '/dashboard' : '/auth/login'}
        className="inline-flex min-h-[44px] items-center rounded-lg bg-indigo-600 px-5 py-2 text-sm font-semibold text-white hover:bg-indigo-700"
      >
        {isAuthenticated ? 'Go to your dashboard' : 'Sign in'}
      </Link>
    </main>
  );
};

export default NotFoundPage;
